module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 193
// module chunks = 0